// import Urls from '@/common/urls'
// import Apiroot from '@/common/apiroot'
// import axios from "axios"
// import jsonp from "jsonp"

const testStore = {};

// var param = {
//     siteCode : 'SITE20210331170738604',
//     domain : 'apitest.frients.net',
//     userEmail : 'v@v.com' ,
//     userPw : '1234',
// };

/**
 * 3개의 도메인으로 테스트 완료
 * CROS 해결 결과
 * 1. npm install --save vue-axios-cors  설치
 * 2. plugins axios.js 파일 5, 6번라인 추가
 * 3. vue.config.js 파일 devServer의 proxy 설정
 */

// axios.post('/company/v1/logon.do', param).then(res => console.log(res));
// axios.post('/api/v1/user/signIn', param).then(res => console.log(res));
// axios.post('/lead/v1/getLeadGroupAllList.do', param).then(res => console.log(res));

export default testStore;
